import { request } from "@/configs/request";

/**
 * Barcha API klasslari uchun umumiy asos. Bitta `request` — bitta joy,
 * ya'ni xato ishlovi, timeout va cookie sozlamalari hech qayerda
 * takrorlanmaydi.
 */
export class BaseApi {
  protected request = request;
}
